export interface FileUploadRequest {
  fileInfoList: {
    fileType: string;
    fileName: string;
  }[];
}

export interface FileUploadData {
  urlList: {
    fileName: string;
    url: string;
  }[];
}

export interface S3UploadError {
  message: string;
  statusCode?: number;
}

export enum FileTypeEnum {
  PRODUCT = 'PRODUCT',
}

export const ALLOWED_FILE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'pdf',
  'mp4',
  'mov',
  'avi',
  'wmv',
  'flv',
  'webm',
] as const;

export type AllowedFileExtension = (typeof ALLOWED_FILE_EXTENSIONS)[number];

export interface FileValidationResult {
  isValid: boolean;
  error?: string;
}

export interface ThumbnailUploadState {
  isLoading: boolean;
  error: string | null;
  editingIndex: number | null;
}

export interface ThumbnailUploadProps {
  thumbnailUrls: string[];
  onThumbnailsChange: (urls: string[]) => void;
  disabled?: boolean;
}

export interface UseThumbnailUploadReturn {
  uploadState: ThumbnailUploadState;
  handleFileUpload: (files: FileList | null) => Promise<void>;
  handleFileEdit: (files: FileList | null, index: number) => Promise<void>;
  handleDelete: (index: number) => void;
  handleImageClick: (url: string) => void;
  setEditingIndex: (index: number | null) => void;
}
